import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
export const useRecipePrefsStore = create()(persist((set, get) => ({
    likedIds: new Set(),
    bookmarkedIds: new Set(),
    isLiked: (id) => get().likedIds.has(id),
    isBookmarked: (id) => get().bookmarkedIds.has(id),
    toggleLike: (id) => {
        const current = get();
        const likedIds = new Set(current.likedIds);
        if (likedIds.has(id)) {
            likedIds.delete(id);
        }
        else {
            likedIds.add(id);
        }
        set({ likedIds });
        return likedIds.has(id);
    },
    toggleBookmark: (id) => {
        const current = get();
        const bookmarkedIds = new Set(current.bookmarkedIds);
        if (bookmarkedIds.has(id)) {
            bookmarkedIds.delete(id);
        }
        else {
            bookmarkedIds.add(id);
        }
        set({ bookmarkedIds });
        return bookmarkedIds.has(id);
    },
    setLike: (id, liked) => {
        const current = get();
        const likedIds = new Set(current.likedIds);
        if (liked) {
            likedIds.add(id);
        }
        else {
            likedIds.delete(id);
        }
        set({ likedIds });
    },
    setBookmark: (id, bookmarked) => {
        const current = get();
        const bookmarkedIds = new Set(current.bookmarkedIds);
        if (bookmarked) {
            bookmarkedIds.add(id);
        }
        else {
            bookmarkedIds.delete(id);
        }
        set({ bookmarkedIds });
    },
    clearAll: () => set({ likedIds: new Set(), bookmarkedIds: new Set() }),
}), {
    name: 'recipe-prefs',
    version: 1,
    storage: createJSONStorage(() => typeof window !== 'undefined' && window.localStorage
        ? window.localStorage
        : {
            getItem: async () => null,
            setItem: async () => { },
            removeItem: async () => { },
        }),
    // Serialize Set since JSON doesn't support it
    partialize: state => ({
        likedIds: Array.from(state.likedIds),
        bookmarkedIds: Array.from(state.bookmarkedIds),
    }),
    onRehydrateStorage: () => state => {
        if (!state)
            return;
        // Convert arrays back to Sets after rehydration
        const anyState = state;
        if (Array.isArray(anyState.likedIds)) {
            anyState.likedIds = new Set(anyState.likedIds);
        }
        if (Array.isArray(anyState.bookmarkedIds)) {
            anyState.bookmarkedIds = new Set(anyState.bookmarkedIds);
        }
    },
}));
export function useRecipePrefsItem(recipeId) {
    const isLiked = useRecipePrefsStore(s => s.isLiked(recipeId));
    const isBookmarked = useRecipePrefsStore(s => s.isBookmarked(recipeId));
    const toggleLike = useRecipePrefsStore(s => s.toggleLike);
    const toggleBookmark = useRecipePrefsStore(s => s.toggleBookmark);
    const setLike = useRecipePrefsStore(s => s.setLike);
    const setBookmark = useRecipePrefsStore(s => s.setBookmark);
    return {
        isLiked,
        isBookmarked,
        toggleLike: () => toggleLike(recipeId),
        toggleBookmark: () => toggleBookmark(recipeId),
        setLike: (liked) => setLike(recipeId, liked),
        setBookmark: (bookmarked) => setBookmark(recipeId, bookmarked),
    };
}
